import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { HOME_TILES } from '../lib/tools';
import { apiGet } from '../lib/api';
import { useAsync } from '../lib/useAsync';
import { TilePreview } from '../components/TilePreview';

// Post-login landing (brief Task 3): 6 large tiles. Entitled tools + CRM/Settings
// are active; unentitled tools are locked with an "Unlock — $X" button straight to
// checkout. This is the upsell surface — locked tools are shown, not hidden.
export default function Home() {
  const { me } = useAuth();
  const navigate = useNavigate();
  const { data } = useAsync(() => apiGet<{ tools: any[] }>('/api/entitlements'), []);
  const owned = new Set(me?.entitlements || []);
  const prices: Record<string, any> = {};
  (data?.tools || []).forEach((t) => (prices[t.id] = t));

  const firstName = me?.user.fullName?.split(' ')[0] || 'there';

  return (
    <div className="mx-auto max-w-5xl px-5 py-10">
      <h1 className="h-display text-4xl text-soft">Hey {firstName}</h1>
      <p className="mt-1 text-muted">Jump into a tool, or unlock a new one.</p>

      <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {HOME_TILES.map((t) => {
          const unlocked = !t.gated || owned.has(t.key);
          const price = prices[t.key];
          return (
            <div
              key={t.label}
              className={`group card relative flex min-h-[180px] flex-col justify-between p-5 transition ${
                unlocked ? 'cursor-pointer hover:border-power hover:shadow-pop' : 'opacity-80'
              }`}
              onClick={() => unlocked && navigate(t.to)}
            >
              <div>
                <div className="flex items-center justify-between">
                  <h2 className="h-display text-2xl text-soft">{t.label}</h2>
                  {!unlocked && <span className="text-lg">🔒</span>}
                </div>
                <p className="mt-1.5 text-sm text-muted">{t.desc}</p>
                {t.preview && (
                  <div className="mt-3 rounded-lg border border-line/70 bg-ink/40 px-2.5 py-2">
                    <TilePreview toolKey={t.preview} />
                  </div>
                )}
              </div>
              {unlocked ? (
                <span className="mt-3 font-head text-sm font-semibold text-electric">Open →</span>
              ) : (
                <button
                  onClick={(e) => { e.stopPropagation(); navigate(`/pricing?tool=${t.key}`); }}
                  className="btn-primary mt-3 w-full text-sm"
                >
                  Unlock{price?.price_label ? ` — ${price.price_label.split(' ')[0]}` : ''}
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
